// test2664
(2664 && 0);
